import React, { useState,useRef,useEffect } from 'react'
import './App.css'
import Markdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import {saveAs} from 'file-saver'
function App() {
  
 
  const inp=useRef(null)
  const sinp=useRef(null)
  useEffect(()=>{
    sinp.current.value='markly.md'

  },[])
  const[state,setstate]=useState('')



  const change=()=>{
    setstate(inp.current.value)
    
  }
  const heading=()=>{
    inp.current.value+='\n# '

    
  }
    const head2=()=>{
    inp.current.value+='\n## '

    
  }
    const head3=()=>{
    inp.current.value+='\n### '

    
  }
  const itallic=()=>{
    inp.current.value+='**'
  }
  const point=()=>{
    inp.current.value+='\n- '
  }
  const bold=()=>{
    inp.current.value+='\n****'
  }

const save = (e) => {
  e.preventDefault();
  const filename = sinp.current.value || 'markly.md';

  
  const blob = new Blob([state], { type: 'text/markdown;charset=utf-8' });
  saveAs(blob, filename);

};

  return (
    <div className='container'>
 

      <div className='navbar'>
        <h1>Markly</h1>
        <button onClick={heading} className='btn'>H1</button>
        <button className='btn' onClick={head2}>H2</button>
        <button onClick={head3} className='btn'>H3</button>
        <button className='btn' onClick={itallic}>𝐼</button>
        <button className='btn'onClick={point}>●</button>
        <button className='btn' onClick={bold}>B</button>
        <input className='inp' ref={sinp} />


        <button className='save' type='button' onClick={save}>SAVE</button>

      </div>
      <textarea ref={inp} className='textbox' placeholder='🌟Markdown here' onChange={change}></textarea>
      
      

     
      <div className='preview' >
        <Markdown rehypePlugins={[rehypeRaw]}>{state}</Markdown>
    
      </div>


    </div>
  )
}

export default App
